import PlanejamentoAcaoFluxo from '../../produto/spa/planejamento-acao/PlanejamentoAcaoFluxo';

export default PlanejamentoAcaoFluxo;
